import React from 'react';
import PropTypes from 'prop-types';
import { AvatarOption, Content, StyledAvatar, Indicator } from './styled';

const Option = ({ variants, onClick, config, withBackground, isSelected, withTop }) => {
  return (
    <AvatarOption>
      <Content
        variants={variants}
        onClick={onClick}
        withBackground={withBackground}
        background={config.background}
        isSelected={isSelected}
      >
        <StyledAvatar withTop={withTop} config={config} />
      </Content>
      {withBackground && <Indicator isSelected={isSelected} />}
    </AvatarOption>
  );
};

Option.propTypes = {
  variants: PropTypes.object,
  onClick: PropTypes.func,
  config: PropTypes.object,
  withBackground: PropTypes.bool,
  isSelected: PropTypes.bool,
  withTop: PropTypes.bool
};

export default Option;
